export const deleteConfirmationOpen = deleteConfirmationSetup => ({
  type: 'DELETE_CONFIRMATION_OPEN',
  deleteConfirmationSetup
});

export const deleteConfirmationClose = () => ({
  type: 'DELETE_CONFIRMATION_CLOSE'
});
